module.exports = __webpack_public_path__ + "static/media/favepay-icon.b390b028.svg";